(() => {
  if (customElements.get('edge-tamer-guide')) return;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tamer-guide-open]');
    if (!trigger) return;
    const guide = document.querySelector('edge-tamer-guide');
    if (guide) guide.open(trigger);
  });
  customElements.define('edge-tamer-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.addEventListener('click', (event) => this.handleClick(event));
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => (this.opener || this.querySelector('[data-open]')).focus());
    }

    open(trigger) {
      this.opener = trigger;
      this.answers = {};
      if (!this.dialog.open) this.dialog.showModal();
      this.show('width');
    }

    show(step) {
      this.querySelectorAll('[data-step]').forEach((panel) => { panel.hidden = panel.dataset.step !== step; });
      this.querySelector('[data-error]').hidden = true;
      this.querySelector(`[data-step="${step}"] h2`).focus();
      this.dialog.scrollTop = 0;
    }

    handleClick(event) {
      const button = event.target.closest('button');
      if (!button || this.busy) return;
      const data = button.dataset;
      if ('open' in data) {
        this.open(button);
      } else if ('close' in data) this.dialog.close();
      else if ('restart' in data) { this.answers = {}; this.show('width'); }
      else if ('width' in data) {
        this.answers.width = Number(data.width);
        this.show(this.answers.width === 3 ? 'power' : 'type');
      } else if ('power' in data) {
        this.answers.power = data.power;
        this.show('type');
      } else if ('type' in data) {
        this.answers.type = data.type;
        if (data.type === 'bolt' && (this.answers.width > 3 || (this.answers.width === 3 && this.answers.power === 'high'))) this.show('holes');
        else this.recommend();
      } else if ('holes' in data) {
        this.answers.holes = data.holes;
        this.recommend();
      } else if ('add' in data) this.addToCart();
    }

    recommend() {
      const { width, power, type, holes } = this.answers;
      const size = width === 1 ? 3 : (width === 2 || (width === 3 && power === 'low')) ? 4 : 6;
      const count = width === 1 ? 2 : width === 2 ? 3 : (width === 3 && power === 'low') ? 4 : width;
      // Match the current multi-piece variants used in the customer's comparison table.
      const title = `${count} Pcs ${type === 'bolt' ? 'Bolt-On Tamer' : 'Edge Tamer'} ${size}" Wide${type === 'bolt' && size === 6 ? ` w/ ${holes}" Bolts` : ''}`;
      const normalize = (value) => value.replace(/\s+/g, '').toLowerCase();
      this.variant = this.variants.find((variant) => normalize(variant.title) === normalize(title));
      this.show('result');
      const recommendation = this.querySelector('[data-recommendation]');
      recommendation.textContent = title;
      const link = this.querySelector('[data-product]');
      link.href = this.dataset.productUrl + (this.variant ? `?variant=${this.variant.id}` : '');
      recommendation.href = link.href;
      this.querySelector('[data-add]').disabled = !this.variant?.available;
      if (!this.variant?.available) this.error('This recommended setup is currently unavailable. Please contact us for help with your setup.');
    }

    error(message) {
      const error = this.querySelector('[data-error]');
      error.textContent = message;
      error.hidden = false;
    }

    async addToCart() {
      if (!this.variant?.available || this.busy) return;
      this.busy = true;
      const button = this.querySelector('[data-add]');
      button.disabled = true;
      button.textContent = 'Adding…';
      this.querySelector('[data-error]').hidden = true;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          // Quantity one is one complete multi-piece setup, not count sets.
          body: JSON.stringify({ items: [{ id: this.variant.id, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this setup. Please try again.');
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.error(error.message || 'Unable to add this setup. Please try again.');
      } finally {
        this.busy = false;
        button.disabled = false;
        button.textContent = 'Add them to your Cart';
      }
    }
  });
})();
